import React from 'react';

export default function SmartInsights({ insights = [] }) {
  /* Default insights with highlighted keywords */
  const defaultInsights = [
    { text: 'XYZ Tours generated the', highlight: 'highest bookings', after: 'this month.', accentColor: '#0d7a71' },
    { text: 'Revenue grew by', highlight: '+12.4% MoM', after: 'compared to last month.', accentColor: '#0d7a71' },
    { text: '70 Duty Slips are', highlight: 'pending invoicing', after: 'worth ₹8.4L.', accentColor: '#e6930a' },
    { text: 'Conversion rate reached', highlight: '76%', after: 'from bookings to invoices.', accentColor: '#2563eb' }
  ];

  const data = insights && insights.length > 0 ? insights : defaultInsights;

  const getAccent = (item) => {
    if (typeof item === 'object' && item.accentColor) {
      return item.accentColor;
    }
    const fullText = (typeof item === 'object' ? `${item.text || ''} ${item.highlight || ''} ${item.after || ''}` : String(item)).toLowerCase();
    if (fullText.includes('decreas') || fullText.includes('declin') || fullText.includes('drop') || fullText.includes('-%')) {
      return '#dc2626';
    }
    if (fullText.includes('pending') || fullText.includes('warning') || fullText.includes('attention')) {
      return '#e6930a';
    }
    if (fullText.includes('conversion') || fullText.includes('rate')) {
      return '#2563eb';
    }
    return '#0d7a71';
  };

  return (
    <div className="dash-card p-3 d-flex flex-column" style={{ height: '100%' }}>
      {/* Header */}
      <div className="mb-2">
        <h6 className="m-0 fw-bold" style={{ fontSize: '13.5px', color: '#0f172a' }}>
          Smart Insights
        </h6>
        <div style={{ width: '30px', height: '3px', backgroundColor: '#0d7a71', borderRadius: '2px', marginTop: '5px' }}></div>
      </div>

      {/* Insight Items */}
      <div className="d-flex flex-column" style={{ gap: '0px', flex: 1 }}>
        {data.map((item, i) => {
          const isObj = typeof item === 'object';
          const accent = getAccent(item);
          const textBefore = isObj ? item.text : '';
          const highlighted = isObj ? item.highlight : item;
          const textAfter = isObj ? item.after : '';

          return (
            <div key={i}>
              <div className="d-flex align-items-start" style={{ padding: '10px 2px 10px 0' }}>
                {/* Left Accent Bar */}
                <div
                  style={{
                    width: '3.5px',
                    minHeight: '32px',
                    backgroundColor: accent,
                    borderRadius: '2px',
                    marginRight: '12px',
                    flexShrink: 0,
                    alignSelf: 'stretch'
                  }}
                ></div>

                {/* Text */}
                <p className="m-0" style={{ fontSize: '12.5px', color: '#1e293b', lineHeight: '1.55', fontWeight: '500' }}>
                  {textBefore}{' '}
                  <span style={{ color: accent, fontWeight: '700' }}>{highlighted}</span>
                  {textAfter ? ' ' + textAfter : ''}
                </p>
              </div>

              {/* Separator line (except last) */}
              {i < data.length - 1 && (
                <div style={{ height: '1px', backgroundColor: '#e2e8f0', marginLeft: '16px' }}></div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
